const Vehicle = {

    // FIELDS
    "registration_number": "Registration Number",
    "make": "Make",
    "model": "Model",
    "year": "Year",
    "color": "Color",
    "mileage": "Mileage",
    "capacity": "Capacity",
    "current_status": "Current Status",
    "driver_attender": "Driver/Attender",
    "warehouse_details": "Ware House Details",
    "business_area": "Business Area",
    "email": "Email",
    "search": "Search",

    // PAGE HEADER
    "vehicle": "Vehicle",

    // ERROR
    "error_registration_number": "Enter Registration Number",
    "error_make": "Enter Make",
    "error_model": "Enter Model",
    "error_year": "Enter Year",
    "error_color": "Enter Color",
    "error_mileage": "Enter Mileage",
    "error_capacity": "Enter Capacity",
    "error_current_status": "Enter Current Status",
    "error_driver_attender": "Select Driver/Attender",
    "error_business_area": "Select Business Area",
    "error_email": "Select Email",

    // TABLE HEADER
    "table_regitration_number": 'REGISTRATION NUMBER',
    "table_make": "MAKE",
    "table_model": "MODEL",
    "table_capacity": "CAPACITY",
    "table_current_status": "CURRENT STATUS",
}

export default Vehicle;